import "./AssignLabToTestViewComponent.scss";
import React from "react";
import StatusCardComponent from "../../../../../shared/components/status-card/statusCardComponent";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";

interface AssignLabToTestViewComponentProps {
    assignedLabs: any;
    canEdit: boolean;
    onEditModeOpen: Function;
}

const AssignLabToTestViewComponent = (props: AssignLabToTestViewComponentProps) => {
    const {assignedLabs, canEdit, onEditModeOpen} = props;

    return (
        <div className={'assign-lab-to-test-view-component  details-tab-data-content'}>
            <div className="details-tab-data-header">
                <div className="view-and-edit-title">Selected Labs(s):</div>
                {canEdit &&
                    <div>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            startIcon={<EditIcon/>}
                            fullWidth={true}
                            handleClick={() => {
                                onEditModeOpen()
                            }}
                        >
                            Edit Details
                        </ButtonComponent>
                    </div>
                }
            </div>
            {
                assignedLabs?.length > 0 ?
                    <div>
                        {
                            assignedLabs?.map((lab: any) => {
                                return (
                                    <div className="lab-card" key={lab.id}>
                                        <div className="lab-name">{lab.name}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    :
                    <StatusCardComponent title={"No Labs Assigned"}/>
            }
        </div>
    );

};

export default AssignLabToTestViewComponent;